<template>
  <div id="pulseResults">
    <el-card
      v-loading="loading"
      class="mainCard clear-card"
      shadow="hover"
      :body-style="{padding: '35px'}"
    >
      <div class="titleContainer">
        <span class="title">Pulse Summary</span>
        <PulseButtons
          :show-type="showType"
        />
      </div>

      <div
        v-if="!pulseData"
        class="noData"
      >
        No data to display
      </div>

      <PulseScoreLeader
        v-if="pulseData"
        :report="pulseData"
      />

      <div
        v-if="responses && Object.keys(responses).length > 0"
        class="customLegendWrap"
      >
        <template v-for="(key) in Object.keys(responses)">
          <div
            v-if="responses[key] && responses[key] > 0"
            :key="`P${key}`"
            class="customLegend"
          >
            <div
              class="indicator"
              :class="key"
            ></div>
            Pulse {{ 'I'.repeat((key.replace('pulse', '') * 1)) }}
          </div>
        </template>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PulseButtons from './PulseButtons.vue';

export default {
  components: {
    PulseButtons,
    PulseScoreLeader: () => import(/* webpackChunkName: "Charts" */ '@/views/dashboard/content/common/welcome/widgets/charts/PulseScoreLeader.vue'),
  },

  props: {
    pulseReport: {
      type: Object,
      default: null,
    },

    showType: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    loading: false,
    localPulseData: null,
    localResponses: {
      pulse1: null,
      pulse2: null,
    },
  }),

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    responses() {
      const resp = this.pulseReport;

      const formattedResponses = {};

      if (resp && resp.pulse1) formattedResponses.pulse1 = resp.pulse1.respondent_ct;
      if (resp && resp.pulse2) formattedResponses.pulse2 = resp.pulse2.respondent_ct;
      if (resp && resp.pulse3) formattedResponses.pulse3 = resp.pulse3.respondent_ct;

      return formattedResponses;
    },

    pulseData() {
      if (this.pulseReport) {
        const pulse = JSON.parse(JSON.stringify(this.pulseReport));
        if (pulse.pulse1) delete pulse.pulse1.respondent_ct;
        if (pulse.pulse2) delete pulse.pulse2.respondent_ct;
        if (pulse.pulse3) delete pulse.pulse3.respondent_ct;
        return pulse;
      }

      return this.localPulseData;
    },
  },
};
</script>

<style lang="scss" scoped>
#pulseResults {
  .el-card {
    margin-bottom: 18px;
    min-height: 417px;

    .titleContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .title {
        font-weight: bold;
      }
    }

    .noData {
      color: #c4c4c4;
      text-align: center;
      padding: 5px 0;
      height: 100%;
      min-height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: italic;
    }

    .nbRespondent {
      display: flex;
      flex-wrap: wrap;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: var(--themeFontColor);
      text-align: left;
      margin: 10px 0 5px 28px;

      .subject {
        padding-right: 10px;
      }

      .pulseDivide {
        padding-right: 10px;
      }

      .textBold {
        font-weight: bold;
      }
    }

    .customLegendWrap {
      display: flex;
      flex-wrap: wrap;

      .customLegend {
        display: flex;
        align-items: center;
        padding: 5px;
        font-size: 14px;

        .indicator {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          margin: 0 8px 0 0;

          &.pulse1 {
            background: #ffb800;
          }

          &.pulse2 {
            background: #00ace2;
          }

          &.pulse3 {
            background: #8d33be;
          }
        }
      }
    }

    .graphDescription {
      font-size: 14px;
      padding-top: 5px;
    }
  }
}
</style>
